// src/components/Newsletter.js
import React, { useState } from 'react';
import './Newsletter.css';

function Newsletter() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  // Basic email validation regex
  const isValidEmail = (emailAddress) => {
    return /\S+@\S+\.\S+/.test(emailAddress);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if email is empty
    if (!email) {
      setMessage('Please enter an email address.');
      return;
    }

    // Validate email format
    if (!isValidEmail(email)) {
      setMessage('Please enter a valid email address.');
      return;
    }

    // TODO: Replace with your API call or subscription logic
    console.log('Subscribing user with email:', email);

    // Reset form and show success message
    setEmail('');
    setMessage('You have successfully subscribed to our newsletter!');
  };

  return (
    <section className="newsletter-section">
      <div className="newsletter-content">
        <h2>Join Our Newsletter</h2>
        <p>Stay informed with updates from LeftRightSolutions. Subscribe for insights and offers!</p>
        <form onSubmit={handleSubmit} className="newsletter-form">
          <input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="newsletter-input"
          />
          <button type="submit" className="newsletter-button">
            Sign up
          </button>
        </form>
        {message && <p className="newsletter-message">{message}</p>}
      </div>
    </section>
  );
}

export default Newsletter;
